module.exports = __webpack_public_path__ + "img/banana.1ea73429.jpg";